
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impressum",
      function () {
        return require("private-next-pages/impressum/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impressum"])
      });
    }
  